/**
 * Master Role Configuration matching backend numerical hierarchy
 */
export const USER_ROLES = {
    GLOBAL_ADMIN: 99,
    TECH_SUPPORT: 93,
    SALES_TEAM: 92,
    FRANCHISE_OWNER: 90,
    REGIONAL_MANAGER: 80,
    STORE_GM: 50,
    SHIFT_SUPERVISOR: 40,
    CASHIER: 30,
    DEMO_CASHIER: 27,
    KITCHEN_CREW: 25,
    INVENTORY_SPECIALIST: 20,
    DELIVERY_DRIVER: 15
};

export const ROLE_NAMES = {
    [USER_ROLES.GLOBAL_ADMIN]: "Global SaaS Admin",
    [USER_ROLES.TECH_SUPPORT]: "SaaS Technical Support",
    [USER_ROLES.SALES_TEAM]: "SaaS Sales Team",
    [USER_ROLES.FRANCHISE_OWNER]: "Franchise Owner / Brand Admin",
    [USER_ROLES.REGIONAL_MANAGER]: "Regional / Area Manager",
    [USER_ROLES.STORE_GM]: "Store General Manager",
    [USER_ROLES.SHIFT_SUPERVISOR]: "Shift Supervisor",
    [USER_ROLES.CASHIER]: "Cashier / Front House",
    [USER_ROLES.DEMO_CASHIER]: "Demo Account (Cashier)",
    [USER_ROLES.KITCHEN_CREW]: "Kitchen Crew (KDS)",
    [USER_ROLES.INVENTORY_SPECIALIST]: "Inventory Specialist",
    [USER_ROLES.DELIVERY_DRIVER]: "Delivery Driver"
};

export const ROLE_COLORS = {
    [USER_ROLES.GLOBAL_ADMIN]: "#9c27b0", // Deep Purple
    [USER_ROLES.TECH_SUPPORT]: "#673ab7", // Purple
    [USER_ROLES.SALES_TEAM]: "#3f51b5", // Indigo
    [USER_ROLES.FRANCHISE_OWNER]: "#1a237e", // Dark Navy
    [USER_ROLES.REGIONAL_MANAGER]: "#0288d1", // Light Blue
    [USER_ROLES.STORE_GM]: "#2e7d32", // Forest Green
    [USER_ROLES.SHIFT_SUPERVISOR]: "#00796b", // Teal
    [USER_ROLES.CASHIER]: "#ed6c02", // Orange
    [USER_ROLES.DEMO_CASHIER]: "#795548", // Brown
    [USER_ROLES.KITCHEN_CREW]: "#d32f2f", // Red
    [USER_ROLES.INVENTORY_SPECIALIST]: "#00bcd4", // Cyan
    [USER_ROLES.DELIVERY_DRIVER]: "#607d8b"  // Blue Grey
};

/**
 * Permission categories for UI customization checkboxes
 */
export const PERMISSION_CATEGORIES = [
    {
        title: "Order & Billing",
        permissions: [
            { id: "orders:create", label: "Create Orders & Payout" },
            { id: "orders:void", label: "Line Item Void" },
            { id: "orders:cancel", label: "Full Order Cancellation" },
            { id: "orders:refund", label: "Process Refunds" },
            { id: "orders:discount", label: "Apply Custom Discounts" }
        ]
    },
    {
        title: "Till & Cash Management",
        permissions: [
            { id: "till:startday", label: "Start Day / Open Till" },
            { id: "till:endday", label: "End Day / Close Till" },
            { id: "till:count", label: "Perform Cash Counts" },
            { id: "till:cashdrop", label: "Perform Cash Drops" },
            { id: "till:paidout", label: "Report Paid Outs" }
        ]
    },
    {
        title: "Kitchen & Production",
        permissions: [
            { id: "kds:view", label: "View KDS Screen" },
            { id: "kds:update", label: "Update Dish Status" }
        ]
    },
    {
        title: "Inventory & Stock",
        permissions: [
            { id: "inventory:view", label: "View Stock Levels" },
            { id: "inventory:adjust", label: "Perform Stock Adjustments" },
            { id: "inventory:purchase_order", label: "Create Purchase Orders" }
        ]
    },
    {
        title: "Reports & Analytics",
        permissions: [
            { id: "reports:daily", label: "View Daily Sales Reports" },
            { id: "reports:payroll", label: "View Employee Time Logs" }
        ]
    }
];

/**
 * Determines which roles a manager can assign to others
 */
export const getAssignableRoles = (currentRole) => {
    const roles = Object.values(USER_ROLES);
    // Users can only assign roles lower in numerical rank than themselves
    return roles.filter(role => role < currentRole).sort((a, b) => b - a);
};

export const getRoleName = (roleCode) => ROLE_NAMES[roleCode] || "Unknown Role";
export const getRoleColor = (roleCode) => ROLE_COLORS[roleCode] || "#757575";